/* 

School Lunch

*/

import SchoolLunch from './SchoolLunch.jsx';

export default SchoolLunch;